import * as Yup from 'yup';

const searchSchema = {
  search: Yup.string(),
};

export default searchSchema;
